<template>
    <section id="start" class="page">
        <header class="main transparent">
            <h1><img class="logo" src="img/logo_white.svg" width="40" alt="" />Rozgrzewka głosu</h1>
        </header>

        <div class="content">
            <div class="scroll with-padding">
                <div class="person">
                    <img src="img/sylwia.png" width="100" height="100" alt="" />
                    <p>SYLWIA PRUSAKIEWICZ-<br />KUCHARSKA</p>
                </div>

                <div data-ride="carousel" id="carousel" class="carousel slide">
                    <div class="carousel-inner" role="listbox">
                        <div class="carousel-item active">
                            <div class="inner">
                                <h2>Dzień dobry!</h2>
                                <p>Pora obudzić ciało i głos, nawet jeśli od porannego rozgardiaszu minęło już trochę czasu. Twój głos to delikatny instrument, który wymaga odpowiedniego traktowania. Tylko wtedy będzie służył Ci najlepiej jak to możliwe przez wiele lat. Dbaj o niego. Przygotuj go do wysiłku, a zniknie większość problemów z głosem.</p>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <div class="inner">
                                <p>Ćwiczyć możesz już rano, a także w ciągu dnia np. przed wystąpieniem, próbą, prezentacją. Także wtedy, gdy odczuwasz znużenie, zmęczenie i spadek energii.</p>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <div class="inner">
                                <p>Do wyboru masz trzy wersje rozgrzewki – krótką (ok. 5 minut) , średnią (ok.10 minut)  i długą (ok.15 minut). W zależności od tego, jaką ilością czasu dysponujesz – wybierz swój wariant. I baw się dobrze :)</p>
                            </div>
                        </div>
                    </div>
                    <ol class="carousel-indicators">
                        <li data-target="#carousel" data-slide-to="0" class="active"></li>
                        <li data-target="#carousel" data-slide-to="1"></li>
                        <li data-target="#carousel" data-slide-to="2"></li>
                    </ol>
                </div>

                <router-link class="btn btn-primary" :to="{ name: 'choice' }">Pomiń</router-link>
            </div>
        </div>

        <footer class="main">
            <p class="partner">Partner aplikacji: <img src="img/logo_isla.png" width="100" alt="" /></p>
        </footer>
    </section>
</template>

<script>
import touch from '../mixins/touch'
import resize from '../mixins/resize'

export default {
    name: 'Start',
    mixins: [touch, resize]
}
</script>
